<qbe-header>
    <qbe-language-switch [activeLanguage]="activeLanguage" (changeLanguage)="setLanguage($event)" [languages]="languages">
    </qbe-language-switch>
    <qbe-phone-link phoneNumber="+359 700 13 014" [label]="'header.callUs' | translate" variant="min"></qbe-phone-link>
</qbe-header>
